import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { IOption } from 'ng-select';

@Injectable()
export class ErrorReportingService {
  constructor(private apiService: ApiService) { }

  // getFestivalTheme(id) {
  //   return this.apiService.get('/festival-theme/' + id).map(data => data);
  // }
  
  // saveFestivalTheme(Data) {
  //   return this.apiService.post("/festival-theme", Data).map(data => data);
  // }

  getListOfErrorReporting(appId) {
    console.log('appId=>', appId);
    return this.apiService.get('/geterrorreportinglist/' + appId).map(data => data);
  }

  getListOfErrorReportingCategories(appId) {
    return this.apiService.get('/geterrorreportingcategorylist/' + appId).map(data => data);
  }

  getErrorReportingCategoryById(id, appId){
    return this.apiService.get('/geterrorreportingcategorydetailsbyid/' + id + '/' + appId).map(data => data);
  }

  createErrorReportingCategory(ER, appid){
    return this.apiService.post('/createerrorreportingcategory/' + appid, ER).map(data => data);
  }

  deleteErrorReportingCategory(id, appid) {
    return this.apiService.delete('/errorreportingcategory/' + appid + '/app/' + id).map(data => data);
  }
  
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/error-reporting-management/error-reporting-management.ts